export const FindMinChannelAverage = {
	name: "FindMinChannelAverage",
	description:"Finds the numeric data channel with the lowest average value",
	parameters: {
	
	},
	output:{
		channelName:{
			type:"string"
		},
		avg:{
			type:"number"
		},
		n:{
			type:"number"
		},
		min:{
			type:"number"
		},
		max:{
			type:"number"
		},
		channel:{
			type:"string"
		}
	}
};